import React, { useEffect } from 'react';
import classNames from 'classnames';
import translate from '../../utilities/translator';
import { pushEvent } from '../../utilities/analytics';
import {
  FB_LOGIN_CLICK,
  GOOGLE_LOGIN_CLICK,
} from '../../constants/analyticEvents';

const LoginBlock = (props) => {
  const {
    className,
    onClose,
    onCloseLater,
    isOpen,
    type,
    sourceBlock,
  } = props;

  useEffect(() => {
    // eslint-disable-next-line no-undef
    if (typeof google !== 'undefined' && google.accounts && typeof initGoogle !== 'undefined') {
      // eslint-disable-next-line no-undef
      /* google.accounts.id.initialize({
        client_id: window.googleSettings?.google_client_id,
        // eslint-disable-next-line no-undef
        callback: handleCredentialResponse
      }); */
      // eslint-disable-next-line no-undef
      initGoogle(); // this is google init function from login.js (travelyo)

      // eslint-disable-next-line no-undef
      google.accounts.id.renderButton(
        document.getElementById('google-login-btn-res'),
        { theme: "outline", size: "large", width: 249, shape: "rectangular" }
      );
    }
  }, []);

  const facebookClick = () => {
    if (typeof FB !== 'undefined' && typeof checkLoginState !== 'undefined') {
      // eslint-disable-next-line no-undef
      FB.login(function(response) {
        if (response.authResponse) {
          // eslint-disable-next-line no-undef
          checkLoginState();
        } else {
          console.log('User cancelled login or did not fully authorize.');
        }
      }, { scope: 'public_profile,email' });
    }
    pushEvent(FB_LOGIN_CLICK, { sourceBlock });
  };

  const googleClick = () => {
    pushEvent(GOOGLE_LOGIN_CLICK, { sourceBlock });
  };

  return (
    <div className={classNames("login-block-wrap", { [className]: className, 'login-block-opened': isOpen, 'login-block-closed': !isOpen })}>
      <div className="login-block flex flex-col">
        <div className="lb-head flex justify-end items-center gap-5 p-5">
          <span className="lb-close" onClick={onClose} aria-label="Close Login">
            <i className="ri-close-line" />
          </span>
        </div>
        <div className="lb-body flex flex-col justify-center">
          <div className="lb-title">{(type === 'departure') ? translate('login.saveDepartingAirportPreferences') : translate('login.saveThesePreferences')}</div>
          <div className="lb-subtitle">{translate('login.loginSubTitle2')}</div>
          <div className="lb-login-buttons">
            <div id="google-login-btn-res" onClick={googleClick}></div>
            <div className="facebook-login-btn-res" onClick={facebookClick}><i className="fb-ico"></i><span>{translate('login.fbBtnTxt')}</span></div>
          </div>
          <div className="lb-foot-txt">
            {translate('login.loginBottomTxt')}
          </div>
          <div className="lb-foot-btn-wrap">
            <button className="lb-foot-btn" onClick={onCloseLater}>{translate('login.maybeLater')}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginBlock;
